import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";

function authHeaders() {
  const token = sessionStorage.getItem("syrakis_token");
  return { Accept: "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

export default function FavoritesPage() {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    fetch("/api/menu/favorites", { credentials: "same-origin", headers: authHeaders() })
      .then((response) => response.ok ? response.json() : { favorites: [] })
      .then((data) => { if (mounted) setFavorites((data.favorites || []).flatMap((group) => group.items || [])); })
      .catch(() => { if (mounted) setFavorites([]); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  return (
    <div className="dashboard-main-body">
      <div className="row justify-content-center">
        <div className="col-xl-9">
          <div className="card p-32 mb-20">
            <div className="d-flex align-items-start gap-16">
              <span className="menu-guide-icon" aria-hidden="true"><Icon icon="solar:star-linear" /></span>
              <div>
                <h4 className="mb-8">Favoritos</h4>
                <p className="text-secondary-light mb-0">Guarda las páginas que usas con frecuencia para encontrarlas rápidamente en el menú lateral.</p>
              </div>
            </div>
          </div>
          {loading ? <div className="card p-24 text-secondary-light">Cargando favoritos...</div> : favorites.length ? (
            <div className="card p-24">
              <h6 className="mb-16">Tus páginas guardadas</h6>
              <div className="row g-3">
                {favorites.map((favorite) => <a key={favorite.id || favorite.key} href={favorite.path} className="col-md-6 text-decoration-none">
                  <span className="favorite-guide-link d-flex align-items-center gap-12 p-16 border radius-8">
                    <Icon icon={favorite.icon || "solar:star-linear"} className="text-warning-600 text-xl" />
                    <span>{favorite.label}</span>
                  </span>
                </a>)}
              </div>
            </div>
          ) : (
            <div className="card p-24">
              <h6 className="mb-12">Aún no tienes favoritos</h6>
              <p className="text-secondary-light mb-0">Abre cualquier página y pulsa la estrella ubicada junto a su título. La página aparecerá automáticamente debajo de Dashboard.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
